import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import Accordion from 'react-bootstrap/Accordion';
import AccordionContext from 'react-bootstrap/AccordionContext';
import { useAccordionButton } from 'react-bootstrap';

function ContextAwareToggle({ children, eventKey, bgColor }) {
  const { activeEventKey } = useContext(AccordionContext) || {};
  const decoratedOnClick = useAccordionButton(eventKey);
  const isExpanded = activeEventKey === eventKey;

  return (
    <div
      onClick={decoratedOnClick}
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        cursor: 'pointer',
        padding: '0.75rem 1.25rem',
        backgroundColor: bgColor,
        color: 'white',
        borderBottom: `1px solid ${bgColor}`,
      }}
    >
      <span>{children}</span>
      <span style={{ fontSize: '0.75rem' }}>
        {isExpanded ? '▲' : '▼'}
      </span>
    </div>
  );
}
ContextAwareToggle.propTypes = {
  children: PropTypes.node.isRequired,
  eventKey: PropTypes.string.isRequired,
};

export default function CollapsibleCard({ title, eventKey, children, defaultOpen, bgColor = '#1e85e5' }) {

  return (
    <Accordion defaultActiveKey={defaultOpen ? eventKey : ''}>
      <Accordion.Item
        eventKey={eventKey}
        style={{
          border: '1px solid #1e85e5',
          borderRadius: '.25rem',
          marginBottom: '1rem',
        }}
      >
        <ContextAwareToggle eventKey={eventKey} bgColor={bgColor}>{title}</ContextAwareToggle>
        <Accordion.Collapse eventKey={eventKey}>
          <div style={{ padding: '1rem', backgroundColor: '#f9f9f9' }}>{children}</div>
        </Accordion.Collapse>
      </Accordion.Item>
    </Accordion>
  );
}

CollapsibleCard.propTypes = {
  title: PropTypes.string.isRequired,
  eventKey: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  defaultOpen: PropTypes.bool,
};

CollapsibleCard.defaultProps = {
  defaultOpen: false,
};
